import React from 'react';

// Whistle (training shift) — the icon library has none, so a small custom SVG
// in the same line style (currentColor stroke).
export const TRAINING_LABEL = 'Training shift (trainer bonus)';

export default function WhistleIcon({ size = 14, title = TRAINING_LABEL, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      aria-label={title}
      style={{ flexShrink: 0, verticalAlign: 'middle', ...style }}
    >
      <title>{title}</title>
      {/* body */}
      <circle cx="9" cy="14" r="5" />
      {/* mouthpiece */}
      <path d="M12.5 10.5 L21 7 v4 l-6.5 1.5" />
      {/* hole */}
      <circle cx="9" cy="14" r="1.2" fill="currentColor" stroke="none" />
      {/* ring */}
      <path d="M5 9.5 3.5 6" />
    </svg>
  );
}

// White chip so the whistle stays visible on any shift colour
export function TrainingChip({ size = 12, style }) {
  return (
    <span
      title={TRAINING_LABEL}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: '#FFFFFF', color: '#1a1a2e',
        borderRadius: '999px', padding: '1px 3px', boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.18)', flexShrink: 0, lineHeight: 1,
        ...style,
      }}
    >
      <WhistleIcon size={size} />
    </span>
  );
}
